export const CREATE_UNITSYSTEM = (gql: any) => gql`
    mutation createUnitsystem($data: CreateUnitsystemInput!) {
        createUnitsystem(data: $data) {
            id
        }
    }
`;
export const DELETE_UNITSYSTEM = (gql: any) => gql`
    mutation deleteUnitsystem($id: ID!) {
        deleteUnitsystem(id: $id) {
            id
        }
    }
`;
export const FIND_UNITSYSTEMS = (gql: any) => gql`
    query findUnitsystems($offset: String, $limit: Int) {
        findUnitsystems(offset: $offset, limit: $limit) {
            cursor
            count
            items {
                id
                code
                name
                createdAt
                privateToken
                publicToken
                status
                token
                units
                updatedAt
            }
        }
    }
`;
export const GET_UNITSYSTEM = (gql: any) => gql`
    query getUnitsystem($id: ID!) {
        getUnitsystem(id: $id) {
            id
            code
            createdAt
            id
            name
            privateToken
            publicToken
            status
            token
            units
            updatedAt
        }
    }
`;
export const UPDATE_UNITSYSTEM = (gql: any) => gql`
    mutation updateUnitsystem($id: ID!, $data: UpdateUnitsystemInput!) {
        updateUnitsystem(id: $id, data: $data) {
            id
        }
    }
`;